<template>
  <footer class="footer pt-5 mt-5">
    <div class="container">
      <div class=" row">
        <div class="col-md-5 mb-4">
          <img src="@/assets/images/ecomedica.png"
               style=" image-rendering: crisp-edges!important;"
               class="img-fluid img-shadow-ligth w-md-30 w-50"
               alt="">
          <p class="mt-4">
            Ecomedica insumos médicos, es una empresa dedicada a la comercialización, administración, almacenamiento,
            logística y distribución de medicamentos e insumos para la salud en los principales institutos y
            organizaciones gubernamentales de país, con cobertura en toda la república mexicana.
          </p>
        </div>
        <div class="col-md-3 offset-lg-1 col-12 mb-4">
          <div>
            <h6 class="text-sm">Contacto</h6>
            <a href="tel:+523330455896"
               class="text-secondary"
               target="_blank">
              (33) 3045 5896
            </a>
            <a href="mailto:contacto@ecomedica.com.mx"
               class="text-secondary"
               target="_blank">
              contacto@ecomedica.com.mx
            </a>
          </div>
        </div>
        <div class="col-md-3 col-12 mb-4">
          <div>
            <h6 class="text-sm">Domicilio</h6>
            <a href="https://goo.gl/maps/5C7TzSGxRSD8NKEt8"
               class="text-secondary"
               target="_blank">
              <p>
                Gante #669 Col. Las Conchas
                Guadalajara, Jal. C.P. 44460
              </p>
            </a>
          </div>
        </div>
        <div class="col-12">
          <hr class="horizontal dark">
          <div class="text-center">
            <p class="text-dark my-4 text-xs font-weight-normal">
              &copy;	 ECOMEDICA INSUMOS MÉDICOS S.A DE C.V.
            </p>
          </div>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  name: "footerLayout"
}
</script>

<style scoped>
.footer {
  background-color: white !important;
  margin-top: 0px !important;
}
</style>